module.exports = __webpack_public_path__ + "static/img/upload.c1edcaa5.png";